import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_TEXT_CONFIG } from './cms-component-text.config';
import { NCmsComponentText } from './cms-component-text.interface';

@Component({
    selector: 'cms-component-text',
    templateUrl: './cms-component-text.component.html',
    standalone: true,
    imports: [HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentTextComponent>(CMS_COMPONENT_TEXT_CONFIG)
export class CmsComponentTextComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentText.IData;
}
